/**
 * useMediaAsset Hook
 *
 * Synchronous lookup against the build-time-generated MEDIA_URLS map (see
 * src/services/media-service.ts). Returns the URL immediately — no async,
 * no loading state, no flash. `loading` and the legacy async `asset` shape
 * are preserved for call-site compatibility but `loading` is always false.
 */

import { getAsset, getCachedAssetUrl } from '@services/media-service';
import type { MediaAsset } from '@app-types/media-asset';

interface UseMediaAssetResult {
  asset: MediaAsset | null;
  loading: boolean;
  url: string | null;
}

export function useMediaAsset(
  name: string | null,
  fallbackUrl?: string
): UseMediaAssetResult {
  if (!name) {
    return { asset: null, loading: false, url: fallbackUrl ?? null };
  }
  const asset = getAsset(name);
  const url = asset?.url ?? getCachedAssetUrl(name) ?? fallbackUrl ?? null;
  return { asset, loading: false, url };
}
